export default __webpack_public_path__ + "static/media/3.cb3dd8c4.jpg";